import { useState, useEffect, useContext } from "react";

import Main from "./components/Main/Main";

import Navbar from "./components/Navbar/Navbar";

import axios from "axios";

import { Route, Routes } from "react-router-dom";

import Materials from "./components/Materials/Materials";

import Material from "./components/Material/Material";

import Footer from "./components/Footer/Footer";

import Shop from "./components/Shop/Shop";

import { Box, Flex } from "@chakra-ui/react";

import Login from "./components/Login/Login";

import GetStarted from "./components/GetStarted/GestStarted";

import BookLesson from "./components/BookLesson/BookLesson";

import Subscribe from "./components/Subscribe/Subscribe";

import { UserContext } from "./contexts/UserContext";

import SuccessPaymentPage from "./components/SuccessPaymentPage/SuccessPaymentPage";

import Cancel from "./components/Cancel/Cancel";

import Inmersion from "./components/Immersion/Immersion";

import WhatStudentsSay from "./components/WhatStudentsSay/WhatStudentsSay";
import WhyMe from "./components/WhyMe/WhyMe";
import SuccessSubscriptionPageNewsletter from "./components/SuccessSubscriptionPage/SuccessSubscriptionPage";
import { Modal } from "./components/Modal/Modal";
import ModalCookies from "./components/ModalCookies/ModalCookies";

import TermsOfService from "./components/TermsOfService/TermsOfService";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import Support from "./components/Support/Support";
import NotFoundPage from "./components/404/404";
import ReactGA from "react-ga4";
const GA_MEASUREMENT_ID = "UA-174175272-1"; // Reemplazalo con tu ID de GA4

function App() {
  const [isOpen, setIsOpen] = useState(true);

  const [gaConsent, setGaConsent] = useState(() => {
    const stored = localStorage.getItem("gaConsent");

    return stored === "true" ? true : stored === "false" ? false : null;
  });

  const [materialesTotales, setMaterialesTotales] = useState([]);
  const { user, setUser } = useContext(UserContext);

  const fetchMaterialesTotales = async () => {
    try {
      const res = await axios.get(`/api/materials/contenidos/totales`);
      setMaterialesTotales(res.data);
    } catch (err) {
      console.error("Error fetching materials:", err);
    }
  };

  useEffect(() => {
    if (gaConsent === true) {
      ReactGA.initialize(GA_MEASUREMENT_ID);
      ReactGA.send("pageview");

      // Evento de scroll
      const handleScroll = () => {
        ReactGA.event({
          category: "Interacción",
          action: "Scroll",
          label: "Usuario hizo scroll por primera vez",
        });
        // Quitamos el listener para que solo lo registre una vez
        window.removeEventListener("scroll", handleScroll);
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [gaConsent]);

  useEffect(() => {
    // Fetch materials on mount
    fetchMaterialesTotales();
    // fetchMateriales();
    // Handle session expiration
    const iat = user?.iat;
    const exp = user?.exp;
    const now = Date.now() / 1000;
    if (iat && exp && now > exp) {
      setUser({});
    }
  }, [user, setUser]);

  const handleAccept = () => {
    localStorage.setItem("gaConsent", "true");
    setGaConsent(true);
    setIsOpen(false);
  };

  const handleDeny = () => {
    localStorage.setItem("gaConsent", "false");
    setGaConsent(false);
    setIsOpen(false);
  };

  return (
    <Flex direction="column" minHeight="100vh">
      <Navbar materialesTotales={materialesTotales} />
      <Box flex="1">
        <Routes>
          <Route
            path="/"
            element={<Main materialesTotales={materialesTotales} />}
          />
          <Route path="/materiales" element={<Materials />} />
          <Route path="/materiales/:type" element={<Materials />} />
          <Route
            path="/materiales/:type/:nombre"
            element={<Material materiales={materialesTotales} />}
          />
          <Route path="/what-students-say" element={<WhatStudentsSay />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/login" element={<Login />} />
          <Route path="/why-me" element={<WhyMe />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/book-a-lesson" element={<BookLesson />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/success" element={<SuccessPaymentPage />} />
          <Route
            path="/success-subscription-newsletter"
            element={<SuccessSubscriptionPageNewsletter />}
          />
          <Route path="*" element={<NotFoundPage />} />

          <Route path="/immersion-2026" element={<Inmersion />} />
        </Routes>
      </Box>
      <Modal />
      <ModalCookies
        gaConsent={gaConsent}
        handleAccept={handleAccept}
        handleDeny={handleDeny}
        isOpen={isOpen}
      />

      <Footer />
    </Flex>
  );
}

export default App;
